/*eslint no-prototype-builtins: "off"*/
import * as React from 'react'
import cx from 'classnames'
import * as styles from './account.filter.styl'
import AccountOption from './account.option'
import SearchBar from '@src/components/common/search.bar'
import { accountsLogo } from '@src/img'
import { filter, includes, toLower, isEmpty, map } from 'lodash'
import { CloudTypeEnum } from '@src/endpoints/services/base.service'
import { orderByField } from '@src/utils/array.utils'
import type { FilterOption } from '../../models'
import type { FilterAccount } from '@src/redux/reducers/filter/default.state'

export interface Props {
  accountsList:
    | FilterOption[]
    | {
        [x: string]: FilterOption
      }
  selectedAccount: FilterAccount
  onChange: (account?: FilterOption) => void
}

const AccountFilter: React.FC<Props> = (props: Props) => {
  const { selectedAccount, onChange, accountsList } = props
  const [searchValue, setSearchValue] = React.useState('')

  function getLogo(data: FilterOption = {} as FilterOption) {
    const { cloud_type } = data
    const isSub = !isOrganization(data)
    return accountsLogo(isSub)[cloud_type]
  }

  function renderAccountOption(
    data: FilterOption,
    isParent: boolean,
    logo: string,
    key: number,
    sub: FilterOption[] = []
  ) {
    return (
      <AccountOption
        isParent={isParent}
        logo={logo}
        key={key}
        data={data}
        selectedAccount={selectedAccount}
        onChange={onSelectAccount}
      >
        {isEmpty(searchValue) && renderAccounts(sub, data?.id)}
      </AccountOption>
    )
  }

  function renderAccount(
    data: FilterOption,
    key: number,
    sub: FilterOption[] = []
  ) {
    const { cloud_type } = data
    switch (cloud_type) {
      case CloudTypeEnum.AWS:
      case CloudTypeEnum.AZURE:
      case CloudTypeEnum.GCP:
        return renderAccountOption(
          data,
          isOrganization(data),
          getLogo(data),
          key,
          sub
        )
      default:
        return null
    }
  }

  function isOrganization(data: FilterOption) {
    return data?.isOrganization
  }
  function isSingle(data: FilterOption) {
    return data?.isSingle
  }

  function isRoot(data: FilterOption) {
    return isOrganization(data) || isSingle(data)
  }

  function renderAccounts(
    data: FilterOption[] = [],
    parent: string,
    root = false
  ) {
    const list = root ? filter(data, o => isRoot(o)) : map(data)
    return !isEmpty(list) ? (
      <div
        role={'account_list'}
        data-parent={parent}
        className={styles.accountsList}
      >
        {map(orderByField({ options: list, key: 'name' }), (a, i) =>
          renderAccount(a, i, map(a?.subItems))
        )}
      </div>
    ) : (
      root && (
        <div role="empty" className={cx(styles.accountsList, styles.empty)}>
          Empty
        </div>
      )
    )
  }

  function onSelectAccount(
    account: FilterOption,
    e: React.ChangeEvent<HTMLInputElement>
  ) {
    onChange(account)
  }

  function onChangeSearch(e: React.ChangeEvent<HTMLInputElement>) {
    const { value } = e.target
    setSearchValue(value)
  }

  function filterList(
    accounts:
      | FilterOption[]
      | {
          [x: string]: FilterOption
        },
    searchValue: string
  ) {
    return filter(accounts, (account: FilterOption) =>
      includes(toLower(account?.name), toLower(searchValue))
    ) as FilterOption[]
  }

  const filteredAccounts = filterList(accountsList, searchValue)

  return (
    <div role={'filter_list'} className={styles.filterOptions}>
      <div>
        <h2>View data by Source:</h2>
        <SearchBar
          onChange={onChangeSearch}
          style={{ margin: 0 }}
          searchValue={searchValue}
          placeholder="Search..."
        />
        {renderAccounts(filteredAccounts, 'none', !searchValue)}
      </div>
      <div />
    </div>
  )
}

export default AccountFilter
